<template>
  <article class="human-card">
    <profile-image
      :src="activeUser.avatar_url"
      :user="activeUser"
      width="100px"
      height="100px"
      class="human-card__profile-image"/>
    <button
      v-b-toggle.people-sidebar
      class="events-sidebar__button">
      <font-awesome-icon icon="chevron-left" class="chevron-icon-left"/>
    </button>
    <div class="human-card__human-info">
      <div class="human-info__username">
        <strong>{{ this.$getUserName(activeUser) }}</strong>
      </div>
      <div class="human-info__phone">
        {{ activeUser.phone || '' | formatPhone }}
      </div>
      <div class="human-info__status">
        <span
          v-if="user"
          class="human-info__message">
          {{ getPayoutMessage(activeUser) }}
        </span>
        <money-message
          v-if="balance && !this.isAccountOwner"
          :type="balance || 0 | getPayoutType"
          :currency="eventsCurrency"
          :money-amount="balance"
        />
      </div>
    </div>
  </article>
</template>

<script>
import { mapState } from 'vuex';
import ProfileImage from '../ProfileImage/ProfileImage';
import MoneyMessage from '../MoneyMessagge/MoneyMessage';

export default {
  name: 'HumanCard',
  components: {
    MoneyMessage,
    ProfileImage,
  },
  props: {
    activeUser: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isAccountOwner: false,
      balance: 0,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      userPayoutsCurrency: (state) => state.events.userPayoutsCurrency,
      eventsCurrency: (state) => state.events.eventsCurrency,
      totalAmount: (state) => state.events.payouts.total_amount,
    }),
  },
  methods: {
    getPayoutMessage(user) {
      this.isAccountOwner = this.activeUser.uid === this.user.user;
      this.balance = this.isAccountOwner ? this.totalAmount : user.amount;
      let message = '';
      if (this.balance > 0) {
        if (!this.isAccountOwner) {
          message = this.$t(`CP.theyOwesMe_${user.gender || '_M'}`);
        }
      }
      if (this.balance < 0 && this.user.gender) {
        message = this.isAccountOwner ? this.$t('CP.myTotalDebt') : this.$t(`CP.iOweThem_${this.user.gender || '_M'}`);
      }
      if (!this.balance) {
        message = this.$t('CP.noDebts');
      }
      return `${message} `;
    },
  },
};
</script>

<style lang="scss" scoped>
  .human-card {
    position: relative;
    display: flex;
    align-content: center;
  }

  .human-card__profile-image {
    margin: 0 24px 0 0;
  }

  .human-card__human-info {
    flex: 1 0 60%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .human-info__username {
    flex: 1 0 100%;
    text-align: left;
    font-size: 24px;
    word-break: break-word;
  }

  .human-info__phone {
    flex: 1 0 100%;
    text-align: left;
    font-size: 16px;
  }

  .human-info__message {
    opacity: 0.6;
  }

  .events-sidebar__button {
    display: none;
    position: absolute;
    top: 6px;
    right: 6px;
    background-color: #FFFFFF;
    border: none;
    outline: none;
    width: 23px;
    height: 23px;
    box-sizing: border-box;
    padding: 0;
    border-radius: 50%;
    .chevron-icon-left {
      color: var(--btn-primary);
      width: inherit;
      height: inherit;
      vertical-align: middle;
    }
  }
  @media screen and (min-width: $breakpoint-sm) and (max-width: $breakpoint-lg) {
    .events-sidebar__button {
      display: block;
    }
  }
</style>
